<template>
	<div class="read-more-wrapper" v-bind:class="{'read-more-open': isOpen, 'add-initial-bottom-margin': bottomMargin}">
		<!-- add the color class that we passed in -->
		<div v-bind:class="{ 'truncate color-scrim': !isOpen, [`color-${color}`]: true }" >
			<div class="color-initial">
				<slot>
				</slot>
			</div>
		</div>
		<button v-if="!!$slots.default" type="button" class="type-small underline add-top-margin" v-on:click="toggleReadMore" ref="button" v-text="buttonText"></button>
	</div>
</template>

<script>
	export default {
		name: 'ReadMore',
		props: {
			color: {
				required: false,
				type: String,
				default: 'off-white',
			},
			moreText: {
				required: false,
				type: String,
				default: 'Read more +',
			},
			lessText: {
				required: false,
				type: String,
				default: 'Read less -',
			},
			closedHeight: {
				required: false,
				type: Number,
				default: 200,
			},
			bottomMargin: {
				required: false,
				type: Boolean,
				default: true,
			},
		},
		data() {
			return {
				isOpen: false,
			}
		},
		computed: {
			buttonText() {
				return this.isOpen ? this.lessText : this.moreText;
			},
		},
		methods: {
			toggleReadMore() {
				this.isOpen = !this.isOpen;
				if (this.isOpen) {
					// focus the button for keyboard accessibility
					this.$nextTick(() => this.$refs.button.focus());
				}
			},
		},
	}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/ReadMore.vue